export const DOWNLOAD_GIF_MAX_DURATION = 20;
export const DOWNLOAD_GIF_DEFAULT_DURATION = 5;
export const DOWNLOAD_GIF_MIN_DURATION = 2;
